/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FormulaInPrescriptionDto
 */
export interface FormulaInPrescriptionDto {
    /**
     * External formula ID from Personalized Nutrients API
     * @type {string}
     * @memberof FormulaInPrescriptionDto
     */
    formulaId: string;
    /**
     * Formula name
     * @type {string}
     * @memberof FormulaInPrescriptionDto
     */
    name: string;
    /**
     * Formula type (0 = Capsule, 1 = Powder)
     * @type {string}
     * @memberof FormulaInPrescriptionDto
     */
    type: string;
    /**
     * Quantity (mapped from supply field)
     * @type {number}
     * @memberof FormulaInPrescriptionDto
     */
    quantity: number;
    /**
     * Formula price
     * @type {number}
     * @memberof FormulaInPrescriptionDto
     */
    price: number;
}

/**
 * Check if a given object implements the FormulaInPrescriptionDto interface.
 */
export function instanceOfFormulaInPrescriptionDto(value: object): value is FormulaInPrescriptionDto {
    if (!('formulaId' in value) || value['formulaId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    return true;
}

export function FormulaInPrescriptionDtoFromJSON(json: any): FormulaInPrescriptionDto {
    return FormulaInPrescriptionDtoFromJSONTyped(json, false);
}

export function FormulaInPrescriptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormulaInPrescriptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'formulaId': json['formulaId'],
        'name': json['name'],
        'type': json['type'],
        'quantity': json['quantity'],
        'price': json['price'],
    };
}

export function FormulaInPrescriptionDtoToJSON(json: any): FormulaInPrescriptionDto {
    return FormulaInPrescriptionDtoToJSONTyped(json, false);
}

export function FormulaInPrescriptionDtoToJSONTyped(value?: FormulaInPrescriptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formulaId': value['formulaId'],
        'name': value['name'],
        'type': value['type'],
        'quantity': value['quantity'],
        'price': value['price'],
    };
}

